import * as Images from 'pos/Images';
import * as SalesStore from '../SalesStore';

import { Permission, Res, TicketLineDTO, TicketLineStatus } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import GetSeatNumber from './getSeatNumber';
import { Message, Modal } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		editLineSeatNumber: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('editLineSeatNumber', Preconditions.ensure(Permission.Ticket_EditSeatNumber), async (line: TicketLineDTO): Promise<Result> => {

	if (line.Status !== TicketLineStatus.New) {
		await Message.show(Res.Msg.MSG_CANNOT_CHANGE_SEAT_NUMBER_OF_ORDERED_LINE());
		return Result.error();
	}

	const result = await Modal.show(GetSeatNumber, { Icon: Images.EditLineSeatNumber, seatNumber: line.SeatNumber });

	if (!result.ok)
		return result;

	await SalesStore.setLineSeatNumber(line, result.value);

	return Result.ok();
});